<template>
    <div class="content-container-white">
        <ModuleHeader title="Kunden">
            <div><ul class="horizontal-list">
                <li>
                    <router-link class="icon-link" :to="{name: 'CustomerAdd'}"><font-awesome-icon icon="plus" class="icon"/> Neu</router-link>
                </li>
            </ul></div>
        </ModuleHeader>
        <div class="container-fluid">

        <div class="loading" v-if="loading && !error">

        </div>

        <div v-if="error" class="error">
            {{ error }}
        </div>

        <div v-if="customers">

                <v-client-table :data="customers" :columns="columns" :options="options">

                    <router-link slot="action" slot-scope="props" class="i-con-h-a" :to="{name: 'CustomerEdit', params: {slug: props.row.slug}}"><i class="i-con i-con-edit"></i></router-link>

                </v-client-table>

        </div></div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import db from "firedb/db";

    export default {
        name: "CustomerDashboard",
        components: {ModuleHeader},
        data: () => {
            return {
                loading: true,
                error: null,
                customers: [],

                columns: ['name', 'slug', 'action'],
                options: {
                    skin: 'table table-hover data-table',
                    filterable: false
                },
            }
        },

        created () {
            // fetch the data when the view is created and the data is
            // already being observed
            this.fetchData()
        },

        methods: {
            fetchData() {
                this.error = this.customers = null;
                this.loading = true;

                db.getAll('customer')
                    .then(data => {
                        this.customers = data;
                        this.loading = false;
                    })
                    .catch(e => this.error = e.message);
            },
        }
    }
</script>

<style scoped lang="scss">

</style>